import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetResult } from './GetResult';
import { IGetSkinTypes } from './GetSkinTypes';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AppService {

  // readonly rootUrl = 'https://sandbox.scderma.orbo.tech/api';
  // readonly clientKey = 'ngpfRN7dJXT2EEmxrVAPXF7a0JKQoOiQxLbdzLfJBIDMu3hoqKKvgrBNO9k53ruv';

  // readonly rootUrl = 'https://skincaredemo.orbo.ai/api';
  // readonly pdfSendUrl = 'https://smartskinadvisor.com/api/sendmail.php';
  // readonly clientKey = 'IOS9B6E7369D7D0CCE2002101AA32CD5EA4078A182CF491C7452487195B801D63E7';

  // readonly rootUrl = 'https://dev.api.drmafiq.orbo.tech/api'; //dev
  readonly rootUrl = 'https://auth.smartskinadvisor.orbo.tech/api'; //prod
  // readonly pdfSendUrl = 'https://smartskinadvisor.com/api/sendmail.php';
  readonly clientKey = 'POS6B6E2569D4D0CCE2002201CV32CD5EA1078A182CF496C7452484195B601D6RE8'; //prod
  // readonly clientKey = 'IOS9B6E7369D7D0CCE2002101AA32CD5EA4078A182CF491C7452487195B801D63E7'; //dev

  constructor(private _http: HttpClient) { }

  checkSkin(image, skinType, age, gender): Observable<IGetResult[]> {
    const form = new FormData();
    form.append('file', image, image.name);
    form.append('skinType', skinType);
    form.append('age', age);
    form.append('gender', gender);
    const options = {
      reportProgress: true
    };
    // return this._http.post<IGetResult[]>(this.rootUrl + '/media/skincaredermafiq/upload?clientkey=' + this.clientKey, form, options);
    return this._http.post<{ success: boolean; statusCode: number; data: any[] }>(
      this.rootUrl + '/media/skinanalysis/upload?clientkey=' + this.clientKey,
      form,
      options
    ).pipe(
      map(response => response.data)
    );
  }

  public GetSkinTypes(): Observable<IGetSkinTypes[]> {
    return this._http.get<{ success: boolean; statusCode: number; data: IGetSkinTypes[] }>(
      this.rootUrl + '/skintypes?clientkey=' + this.clientKey
    ).pipe(
      map(response => response.data)  // Extract only the 'data' array
    );
  }

  public SignInApp(id, Mobile): Observable<any> {
    // const options = {
    //   reportProgress: true
    // };

    return this._http.post<any>(this.rootUrl + '/auth/otp?clientkey=' + this.clientKey, {
      session_id: id,
      phone: Mobile
    });
  }

  public OTPverifyApp(id, Mobile, otp, data): Observable<any> {
    // const options = {
    //   reportProgress: true
    // };

    return this._http.post<any>(this.rootUrl + '/auth/verify?clientkey=' + this.clientKey, {
      session_id: id,
      phone: `91${Mobile}`,
      otp: otp,
      data: data
    });
  }

  // public sendPdf(name, mobile, email, pdf): Observable<any> {
  //   const form = new FormData();
  //   form.append('name', name);
  //   form.append('mobile', mobile);
  //   form.append('email', email);
  //   form.append('pdf', pdf.toString());
  //   const options = {
  //     reportProgress: true
  //   };
  //   return this._http.post<any>(this.pdfSendUrl, form, options);
  // }
}
